// Minimal IATA→coords table for the premium flight panel's route row +
// progress bar. Regional focus (Iraq + common orig/dest). Unknown airports
// degrade gracefully (panel shows codes, no progress bar).
export const AIRPORTS = {
  // Iraq
  BGW: { name: 'Baghdad', lat: 33.2625, lon: 44.2346 },
  EBL: { name: 'Erbil', lat: 36.2376, lon: 43.9632 },
  BSR: { name: 'Basra', lat: 30.5491, lon: 47.6621 },
  NJF: { name: 'Najaf', lat: 31.9898, lon: 44.4043 },
  ISU: { name: 'Sulaymaniyah', lat: 35.5617, lon: 45.3167 },
  KIK: { name: 'Kirkuk', lat: 35.4695, lon: 44.3489 },
  OSM: { name: 'Mosul', lat: 36.3058, lon: 43.1474 },
  // Gulf
  DXB: { name: 'Dubai', lat: 25.2532, lon: 55.3657 },
  SHJ: { name: 'Sharjah', lat: 25.3286, lon: 55.5172 },
  AUH: { name: 'Abu Dhabi', lat: 24.4330, lon: 54.6511 },
  DOH: { name: 'Doha', lat: 25.2731, lon: 51.6081 },
  KWI: { name: 'Kuwait City', lat: 29.2266, lon: 47.9689 },
  BAH: { name: 'Bahrain', lat: 26.2708, lon: 50.6336 },
  RUH: { name: 'Riyadh', lat: 24.9576, lon: 46.6988 },
  JED: { name: 'Jeddah', lat: 21.6796, lon: 39.1565 },
  DMM: { name: 'Dammam', lat: 26.4712, lon: 49.7979 },
  MED: { name: 'Medina', lat: 24.5534, lon: 39.7051 },
  MCT: { name: 'Muscat', lat: 23.5933, lon: 58.2844 },
  // Levant / Türkiye / Egypt
  BEY: { name: 'Beirut', lat: 33.8209, lon: 35.4884 },
  AMM: { name: 'Amman', lat: 31.7226, lon: 35.9932 },
  DAM: { name: 'Damascus', lat: 33.4115, lon: 36.5156 },
  CAI: { name: 'Cairo', lat: 30.1219, lon: 31.4056 },
  IST: { name: 'Istanbul', lat: 41.2753, lon: 28.7519 },
  SAW: { name: 'Istanbul Sabiha', lat: 40.8986, lon: 29.3092 },
  ESB: { name: 'Ankara', lat: 40.1281, lon: 32.9951 },
  ADA: { name: 'Adana', lat: 36.9822, lon: 35.2803 },
  GZT: { name: 'Gaziantep', lat: 36.9472, lon: 37.4787 },
  // Iran / Caucasus
  IKA: { name: 'Tehran IKA', lat: 35.4161, lon: 51.1522 },
  THR: { name: 'Tehran Mehrabad', lat: 35.6892, lon: 51.3134 },
  MHD: { name: 'Mashhad', lat: 36.2352, lon: 59.6410 },
  EVN: { name: 'Yerevan', lat: 40.1473, lon: 44.3959 },
  GYD: { name: 'Baku', lat: 40.4675, lon: 50.0467 },
  TBS: { name: 'Tbilisi', lat: 41.6692, lon: 44.9547 },
  // Europe hubs (common long-haul orig/dest)
  FRA: { name: 'Frankfurt', lat: 50.0379, lon: 8.5622 },
  LHR: { name: 'London Heathrow', lat: 51.4700, lon: -0.4543 },
  VIE: { name: 'Vienna', lat: 48.1103, lon: 16.5697 },
};

export function getAirport(iata) {
  return (iata && AIRPORTS[iata]) || null;
}

export function haversineKm(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) * Math.cos((lat2 * Math.PI) / 180) * Math.sin(dLon / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(a));
}

/**
 * Progress for the panel bar. Prefers the API's actual flown distance
 * (FR24 flight-summary) over the computed great-circle from origin.
 * Returns null when the destination is unknown (no bar, codes still shown).
 */
export function flightProgress({ origIata, destIata, lat, lon, flownKm }) {
  const dest = getAirport(destIata);
  if (!dest) return null;
  const remainingKm = haversineKm(lat, lon, dest.lat, dest.lon);
  let flown = Number.isFinite(flownKm) ? flownKm : null;
  if (flown == null) {
    const orig = getAirport(origIata);
    if (!orig) return null;
    flown = haversineKm(orig.lat, orig.lon, lat, lon);
  }
  const pct = Math.max(0, Math.min(100, (flown / Math.max(1, flown + remainingKm)) * 100));
  return { flownKm: Math.round(flown), remainingKm: Math.round(remainingKm), pct };
}
